import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./Post.css";
const Postedit = () => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    image: null,
    quantity: "",
    currentImage: null,
  });
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    fetchPost();
  }, [id]);

  const fetchPost = async () => {
    try {
      const token = localStorage.getItem("access");
      const response = await fetch(
        `https://ambatturindustrialestate.com/api/api/posts/${id}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setFormData({
          title: data.title,
          description: data.description,
          quantity: data.quantity,
          image: null,
          currentImage: data.image,
        });
      } else {
        setMessage("Failed to fetch post details.");
      }
    } catch (error) {
      console.error("Error fetching post:", error);
      setMessage("An error occurred while fetching the post.");
    } finally {
      setFetchLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleImageChange = (e) => {
    setFormData({
      ...formData,
      image: e.target.files[0],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("access");
      const formDataToSend = new FormData();

      formDataToSend.append("title", formData.title);
      formDataToSend.append("description", formData.description);
      formDataToSend.append("quantity", formData.quantity);
      if (formData.image) {
        formDataToSend.append("image", formData.image);
      }

      const response = await fetch(
        `https://ambatturindustrialestate.com/api/api/posts/${id}/`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formDataToSend,
        }
      );

      if (response.ok) {
        setMessage("Post updated successfully!");
        setTimeout(() => {
          navigate("/post");
        }, 1500);
      } else {
        const errorData = await response.json();
        setMessage(errorData.detail || "Failed to update post.");
      }
    } catch (error) {
      console.error("Error updating post:", error);
      setMessage("An error occurred while updating the post.");
    } finally {
      setLoading(false);
    }
  };

  if (fetchLoading) {
    return (
      <div className="editpost-container container mt-4">
        <div className="editpost-loading d-flex justify-content-center">
          <div className="editpost-spinner spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="editpost-container container mt-4">
      <div className="editpost-row row justify-content-center">
        <div className="editpost-col col-md-8">
          <div className="editpost-card card">
            <div className="editpost-card-header card-header">
              <h4 className="editpost-card-title card-title mb-0">Edit Post</h4>
            </div>
            <div className="editpost-card-body card-body">
              {message && (
                <div
                  className={`editpost-alert alert ${
                    message.includes("successfully")
                      ? "alert-success"
                      : "alert-danger"
                  } alert-dismissible fade show`}
                >
                  {message}
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setMessage("")}
                  ></button>
                </div>
              )}

              <form onSubmit={handleSubmit} className="editpost-form">
                <div className="editpost-field mb-3">
                  <label htmlFor="title" className="editpost-label form-label">
                    Title *
                  </label>
                  <input
                    type="text"
                    className="editpost-input form-control"
                    id="title"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="editpost-field mb-3">
                  <label
                    htmlFor="description"
                    className="editpost-label form-label"
                  >
                    Description *
                  </label>
                  <textarea
                    className="editpost-textarea form-control"
                    id="description"
                    name="description"
                    rows="5"
                    value={formData.description}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <div className="editpost-field mb-3">
                  <label
                    htmlFor="quantity"
                    className="editpost-label form-label"
                  >
                    Quantity
                  </label>
                  <input
                    type="text"
                    className="editpost-input form-control"
                    id="quantity"
                    name="quantity"
                    value={formData.quantity}
                    onChange={handleChange}
                  />
                </div>

                <div className="editpost-field mb-3">
                  <label htmlFor="image" className="editpost-label form-label">
                    Image
                  </label>
                  {formData.currentImage && (
                    <div className="editpost-image-preview mb-2">
                      <img
                        src={formData.currentImage}
                        alt="Current"
                        className="editpost-current-image img-thumbnail"
                      />
                    </div>
                  )}
                  <input
                    type="file"
                    className="editpost-file form-control"
                    id="image"
                    name="image"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                  <div className="editpost-help form-text">
                    Upload a new image to replace the current one.
                  </div>
                </div>

                <div className="editpost-actions d-flex justify-content-between">
                  <button
                    type="button"
                    className="editpost-btn editpost-btn-secondary"
                    onClick={() => navigate("/posts")}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="editpost-btn editpost-btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Updating..." : "Update Post"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Postedit;
